import {
  createAsyncThunk,
  createSlice,
  createSelector,
} from "@reduxjs/toolkit";
import DataService from "@untyped-services/dataService";

const dataService = new DataService();

export const getSurveyResults = createAsyncThunk(
  "surveys/getSurveyResults",
  async ({ encodedId }: { encodedId: string }, thunkAPI) => {
    const url = `/api/surveys/${encodedId}/results`;
    const jwt = (thunkAPI.getState() as { jwt: { token: string | null } }).jwt
      .token;

    const data = await dataService
      .getData(url, jwt)
      .then((res: { data: unknown }) => res.data);
    return data;
  },
);

const surveyResultsSlice = createSlice({
  name: "surveyResults",
  initialState: {
    error: "",
    questions: [] as unknown[],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSurveyResults.pending, (draftState) => {
        draftState.loading = true;
      })
      .addCase(getSurveyResults.fulfilled, (draftState, action) => {
        draftState.loading = false;
        draftState.questions = (
          action.payload as { questions: unknown[] }
        ).questions;
      })
      .addCase(getSurveyResults.rejected, (draftState, action) => {
        draftState.loading = false;
        draftState.error = action.error.message ?? "An error occurred";
      });
  },
});

// Selectors
export const selectSurveyResultsState = (state: {
  surveyResults: { error: string; questions: unknown[]; loading: boolean };
}) => state.surveyResults;

export const selectIsLoading = createSelector(
  [selectSurveyResultsState],
  (state) => state.loading,
);

export const selectError = createSelector(
  [selectSurveyResultsState],
  (state) => state.error,
);

export default surveyResultsSlice.reducer;
